/**
 * @module views\sys\charts\template
 */
import Vue from "vue";
import Component from "vue-class-component";
import GhBase from "@/components/ghBase";
import { Watch } from "vue-property-decorator";
import GhTablePage from "@/components/ghTablePage/ghTablePage";

@Component
export default class Template extends GhBase {
  private selectedNode: IndexObject = {};

  private tabs: IGhTab[] = [
    {
      title: "子表维护",
      drawer: true
    },
    {
      title: "数据项维护"
    }
  ];

  @Watch("selectedNode")
  private updateArgs() {
    console.log(this.selectedNode);
    if (this.selectedNode.key) {
      this.args.parent_id = this.selectedNode.key;
    }
  }

  private args = { parent_id: "-1" };

  @Watch("args", { deep: true })
  private refresh() {
    let p = this.$refs.table as GhTablePage;
    p.query(this.args);
  }

  private beforeSave(item: IndexObject) {
    if (this.selectedNode) {
      if (this.selectedNode.key) {
        // item["ParentId"] = this.selectedNode.key;
        this.$set(item, "ParentId", this.selectedNode.key);
      }
    }
  }
}
